// Shared global map setting variables.

export type MapSettings = {
	mapScaleMin: number;
	mapScaleMax: number;
	transitionDuration: number;
};

const mapSettings: MapSettings = {
	mapScaleMin: 1,
	mapScaleMax: 10,
	transitionDuration: window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ? 0 : 750,
};

export default mapSettings;
